"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationActionEnum = void 0;
var NotificationActionEnum;
(function (NotificationActionEnum) {
    NotificationActionEnum["OK"] = "OK";
    NotificationActionEnum["Reject"] = "REJECT";
    NotificationActionEnum["RejectFail"] = "REJECT_FAIL";
    NotificationActionEnum["Accept"] = "ACCEPT";
    NotificationActionEnum["AcceptFail"] = "ACCEPT_FAIL";
    NotificationActionEnum["Cancel"] = "CANCEL";
    NotificationActionEnum["Timeout"] = "TIMEOUT";
    NotificationActionEnum["GoToConversation"] = "GO_TO_CONVERSATION";
    NotificationActionEnum["Ignore"] = "IGNORE";
    NotificationActionEnum["AnsweredElsewhere"] = "ANSWERED_ELSEWHERE";
    NotificationActionEnum["ContactHangedUp"] = "CONTACT_HANGED_UP";
    NotificationActionEnum["SystemHangedUp"] = "SYSTEM_HANGED_UP";
})(NotificationActionEnum = exports.NotificationActionEnum || (exports.NotificationActionEnum = {}));
